module.exports = __webpack_public_path__ + "static/img/icon-prompt-pop-up.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon-prompt-pop-up.png
// module id = 176
// module chunks = 0